<template>
    <div class="d-flex align-center ga-3 flex-wrap">
        <template v-if="paused">
            <v-switch :model-value="true" color="warning" label="Pause inventory generation" density="compact" hide-details inset :loading="processing" @update:model-value="resume" />
            <v-chip color="warning" rounded>Paused</v-chip>
            <v-alert v-if="errorMessage" type="error" density="compact">{{ errorMessage }}</v-alert>
        </template>
        <GenericActionDialog v-else title="Pause Inventory Generation" :disabled="processing" :loading="processing" @open="clearError" @confirm="pause" @cancel="revert">
            <template #activator="{ props: activatorProps }">
                <v-switch v-bind="activatorProps" v-model="pendingOn" color="warning" label="Pause inventory generation" density="compact" hide-details inset />
            </template>
            <template #body>
                <PauseInventoryGenerationDialog :item="property" />
                <v-alert v-if="errorMessage" type="error" density="compact" class="mt-4">{{ errorMessage }}</v-alert>
            </template>
        </GenericActionDialog>
    </div>
</template>

<script setup lang="ts">
import { type IProperty } from '@app/land-hold/property/models/Property';
import { usePropertyRepository } from '@app/land-hold/property/repositories/usePropertyRepository';

const props = defineProps({
    property: {
        type: Object as PropType<IProperty>,
        required: true,
    },
});

const { command } = usePropertyRepository();
const { execute: pauseExecute } = command.updateInventoryGenerationPause(props.property.id, true, { onError: setError });
const { execute: resumeExecute } = command.updateInventoryGenerationPause(props.property.id, false, { onError: setError });

const paused = computed(() => props.property.inventory_generation_paused);
const pendingOn = ref(paused.value);
const processing = ref(false);
const errorMessage = ref('');

watch(paused, (value) => {
    pendingOn.value = value;
});

function pause(close: () => void) {
    processing.value = true;
    errorMessage.value = '';
    pauseExecute({
        onSuccess: () => {
            close();
        },
        onFinish: () => {
            processing.value = false;
        },
    });
}

function resume() {
    if (processing.value) {
        return;
    }
    processing.value = true;
    errorMessage.value = '';
    resumeExecute({
        onFinish: () => {
            processing.value = false;
        },
    });
}

function revert() {
    pendingOn.value = false;
}

function clearError() {
    errorMessage.value = '';
}

function setError(errors: Record<string, string>) {
    errorMessage.value = Object.values(errors).flat().join(', ') || 'Something went wrong. Please try again.';
}
</script>
